import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arabicPrice'
})
export class ArabicPricePipe implements PipeTransform {

  transform(value?: number): any {
    if (!value)
      return null;

    return value.toLocaleString('ar-EG');
  }
}
